// extracted by mini-css-extract-plugin
export default {"fullscreenLoader":"FullScreenLoader_fullscreenLoader__J2F4n","ripple":"FullScreenLoader_ripple__fHQZY"};